import React from 'react';
import bgImage from '../images/Dark_Metal_Grate.jpg'; 
const Home = () => {
  return (
    <div className="image-container">
      <img src={bgImage} alt="Background Image" className="bg-img" />
      <h1 className="centered-text  glow-effect">DISRUPT ARTISTS</h1>
    </div>
  );
};

export default Home;
